<template>
  <select class="form-control" v-model="localCountry">
    <option
      v-for="(country, abbreviation) in countries"
      :key="abbreviation"
      :value="abbreviation"
      >{{ abbreviation }} - {{ country }}</option
    >
  </select>
</template>
<script>
import { countriesCollection } from "@/firebase";
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  methods: {
    getCountries() {
      const self = this;
      countriesCollection.get().then(function(querySnapshot) {
        self.countries = {};
        querySnapshot.forEach(function(doc) {
          let abbr = doc.id.toUpperCase();
          let name = doc.data().name;
          //needed to be able to push variable key and value and have vue update appropriately
          let c = {};
          c[abbr] = name;
          Object.assign(self.countries, c);
        });
        //console.log(self.countries);
      });
    }
  },
  computed: {
    /*states:{
                get: function(){
                    console.log("computed", this.localCountrys);
                    return this.localCountrys;
                },
                set: function(s){
                    this.localCountry = s;
                }
            },*/
    localCountry: {
      get() {
        return this.value;
      },
      set(localCountry) {
        this.$emit("input", localCountry);
      }
    }
  },
  mounted() {
    this.getCountries();
  },
  data() {
    return {
      countries: {}
    };
  }
  /*watch:{
      countries(c,o){
          //console.log("watcher",c,o);
      }
  }*/
};
</script>
